import { InquiryStatus, OfferStatus } from '@paladin-monorepo/common';
import { Badge } from './ui/badge';
import { useTranslation } from 'react-i18next';
import { AlertTriangleIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export const InquiryStatusBadge = ({
  status,
  className,
}: {
  status: InquiryStatus;
  className?: string;
}) => {
  const { t } = useTranslation();
  const variants = {
    [InquiryStatus.Draft]: 'secondary',
    [InquiryStatus.InReview]: 'outline',
    [InquiryStatus.Published]: 'default',
    [InquiryStatus.Archived]: 'outline',
    [InquiryStatus.Evaluated]: 'success',
  } as const;

  return (
    <Badge
      variant={variants[status]}
      className={cn(
        status === InquiryStatus.Published &&
          'border-transparent bg-tint-blue font-label text-brand-secondary hover:bg-tint-blue',
        className,
      )}
    >
      {t(`inquiries.status.${status}`)}
    </Badge>
  );
};

export const OfferStatusBadge = ({ status, rejected }: { status: OfferStatus, rejected?: boolean }) => {
  const { t } = useTranslation();
  const variants = {
    [OfferStatus.Draft]: 'secondary',
    [OfferStatus.InReview]: 'outline',
    [OfferStatus.Submitted]: 'default',
    [OfferStatus.Accepted]: 'default',
    [OfferStatus.Rejected]: 'destructive',
  } as const;

  return (
    <div className='flex flex-row items-center gap-2'>
      <Badge variant={variants[status]}>{t(`offers.status.${status}`)}</Badge>
      {rejected && status === OfferStatus.Draft && (<span className="text-orange-300" title={t('offers.detail.rejected')}><AlertTriangleIcon className="w-4 h-4" /></span>)}
    </div>
  );
};
